import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getcustomer_surveyHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "customersurvey", ...action.payload }),
		);
		yield put({
			type: types.GET_CUSTOME_SURVEY_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_CUSTOME_SURVEY_ERROR,
			payload,
		});
	}
}

export function* getcustomer_surveyWatcherSaga() {
	yield takeLatest(
		types.GET_CUSTOME_SURVEY_START,
		getcustomer_surveyHandlerSaga,
	);
}

//create

//delete

function* deletecustomer_surveyHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("customersurvey", action.payload),
		);
		yield put({
			type: types.DELETE_CUSTOME_SURVEY_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_CUSTOME_SURVEY_ERROR,
			payload,
		});
	}
}

export function* deletecustomer_surveyWatcherSaga() {
	yield takeLatest(
		types.DELETE_CUSTOME_SURVEY_START,
		deletecustomer_surveyHandlerSaga,
	);
}

//update
